import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { rgba } from "polished";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";

import { Title, Section, Box, Text } from "../../components/Core";
import { device } from "../../utils";

import svgCurve from "../../assets/image/svg/l1-curve-content2.svg";

const ShapeTop = styled(Box)`
  position: absolute;
  top: 0;
  left: -150px;
  img {
    min-width: 100%;
  }
`;

const ShapeCard = styled(Box)`
  position: absolute;
  width: 225px;
  top: 5%;
  left: 30%;
 @media ${device.xs} {
  width: 250px;
  z-index: 2;
 }
  transform: scale(0.85);
  @media ${device.sm} {
    width: 305px;
    transform: scale(1);
    top: 6%;
    left: 25%;

  }
  @media ${device.md} {
    width: 400px;
    top: 0;
  }
  @media ${device.lg} {
    width: 305px;
    top: 25%;
}
`;

const ContentCard = ({
  color = "primary",
  className,
  iconName,
  title,
  children,
  ...rest
}) => (
  <Box
    width={360}
    bg="light"
    border="1px solid"
    borderColor="border"
    p="20px"
    borderRadius={10}
    className={`d-flex ${className}`}
    {...rest}
    css={`
      min-width: 100%;
      width: 100%;
      @media ${device.sm} {
        width: 360px;
        min-width: 360px;
      }
      `}
  >
    <Box
      size={55}
      minWidth={55}
      borderRadius="50%"
      color={color}
      fontSize="28px"
      className="d-flex justify-content-center align-items-center"
      css={`
        background-color: ${({ theme, color }) =>
          rgba(theme.colors[color], 0.1)};
        `}
      mr={3}
    >
      <i className={`fab ${iconName}`}></i>
    </Box>
    <div>
      <Title variant="card" mb={0}>
        {title}
      </Title>

      <Text>{children}</Text>
    </div>
  </Box>
);

const Content2 = () => (
  <>
    {/* <!-- Content section 2 --> */}
    <Section bg="#f7f7fb" className="position-relative">
      <ShapeTop>
        <img src={svgCurve} alt="" className="img-fluid" />
      </ShapeTop>
      <Container>
        <Row className="align-items-center">
          <Col lg="5" md="9" sm="10" className="mb-5 mb-lg-0">
            <div className="position-relative">
              <div
                data-aos="fade-down"
                data-aos-duration="750"
                data-aos-once="true"
              >
                <StaticImage src="../../assets/image/png/ProductPage-optimized.png" alt="" className="img-fluid" />
              </div>
              <ShapeCard
                p="18px"
                borderRadius={0}
                className="d-flex align-items-start"
                data-aos="fade-left"
                data-aos-duration="750"
                data-aos-once="true"
                data-aos-delay="500"
              >
                <StaticImage src="../../assets/image/png/ShareProduct-optimized.png" alt="" className="img-fluid" />

              </ShapeCard>
            </div>
          </Col>
          <Col lg="7">
            <div
              data-aos="fade-left"
              data-aos-duration="750"
              data-aos-once="true"
            >
              <div className="content-text pl-lg--50">
                <div className="section-title">
                  <Title>
                    Easily share your store<br className="d-none d-sm-block" />{" "}
                    and products.
                  </Title>
                  <Text mb={4}>
                    You can share your store or any product in your store over WhatsApp, Facebook or any other platform with ease.
                  </Text>
                </div>
                <div className="mt-5">
                  <ContentCard
                    title="Share to your list"
                    color="success"
                    iconName="fa-whatsapp"
                    mb={3}
                  >
                    or directly with a customer.
                  </ContentCard>
                  <ContentCard
                    title="Share to all your groups"
                    color="secondary"
                    iconName="fa-facebook"
                  >
                    in just one go!
                  </ContentCard>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Section>
  </>
);

export default Content2;
